<template>
    <v-select
        multiple
        :filterable="true"
        :options="options"
        v-model="selected"
        :placeholder="placeholder"
        @input="val => { onChange(val); }"
    />
</template>

<script>
import vSelect from "vue-select";

export default {
    components: {
        vSelect,
    },
    props: {
        multiple: {
            type: Boolean,
            default: false,
        },
        draw: {
            type: Number,
        },
        placeholder: {
            type: String
        },
        value: {
            type: Object
        }
    },
    data() {
        return {
            baseUrl: "/api/wms/v1/inter-storage/get-warehouse-filter",
            options: [],
            selected: []
        };
    },
    methods: {
        get() {
            this.$http.get(this.baseUrl, {
                params: {
                    search: "",
                }
            })
            .then(resp => {
                if (resp.code == 200) {
                    this.options.push({ id: 0, label: 'All' });
                    this.options.push(...resp.data.records);

                    // ...
                    this.selected.push({ id: 0, label: 'All' });
                } else {
                    this.options = []
                }
            })
            .catch(error => {
                console.log(error)
            });
        },
        onChange(val) {
            if (!val.length) {
                this.selected[0] = this.options[0]
            } else if (val.length > 1) {
                let lastItem = val.slice(-1)[0];
                if (lastItem.id == 0) {
                    this.selected = [];
                    this.selected[0] = this.options[0]
                } else {
                    this.selected = this.selected.filter(item => item.id !== 0);
                }
            }
        },
        onInput(search, loading) {
            if (search != "") {
                loading(true);
                this.onSearch(search, loading);
            } else {
                loading(true);
                this.onSearch("", loading);
            }
        },
        onSearch(search, loading) {
            this.$http.get(this.baseUrl, {
                params: {
                    search: search,
                }
            })
            .then(resp => {
                if (resp.code == 200) {
                    this.options = [];
                    this.options.push({ id: 0, label: 'All' });
                    this.options.push(...resp.data.records);
                    loading(false);
                } else {
                    this.options = []
                    loading(false);
                }
            })
            .catch(error => {
                console.log(error)
            });
        }
    },
    watch: {
        selected(v) {
            this.selected = v;
            this.$emit("selected", v);
        },
        value(v) {
            if (v) {
                this.selected = v
            }
        }
    },
    mounted() {
        this.get();
    }
};
</script>